module.exports = __webpack_public_path__ + "img/what-is-api-portal-thumbnail.e8872c5a.jpg";